

import React, { Fragment, useState, useEffect } from 'react';
import { Link, useHistory, useParams } from 'react-router-dom';
import { postData, fetchData, updateData } from '../../../apiService';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, IconButton } from "@mui/material";
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import CloseIcon from '@mui/icons-material/Close';
import CopyrightIcon from '@mui/icons-material/Copyright';

const JournalEntryDetails = ({ match }) => {
    const { id } = useParams();
    const { isAuthenticated, companyId, branchId, userId, permissions, token, logout, branchstate } = useAuth();
    const [selectedItems, setSelectedItems] = useState([]);

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
    }, [isAuthenticated, companyId, token, logout]);

    useEffect(() => {
        fetchData('JournelEntryAPI', `/${id}`, token)
            .then((response) => {
                if (response.responseCode === '1111') {
                    setFormData(response.response_data.JournalEntry);
                    setSelectedItems(response.response_data.JournalEntryDetails);
                }
            })
            .catch((error) => {
                console.error('Error fetching JournelEntry Details:', error);
            });
    }, [id]);

    const [formData, setFormData] = useState({
        CompanyId: companyId,
        IsType: true, // Default to "Receipt" (1 for Receipt, 0 for Payment)
        BillDate: "", // Or set to today's date
        Remarks: "",
        Amount: "",
        PaymentType: 1, // Default to "Cash"
        BillNumber: "",
        FinYear: "",
        createdBy: userId,
        isSubmit: false,
    });

    const [isFullScreen, setIsFullScreen] = useState(false);
    useEffect(() => {
        function handleResize() {
            setIsFullScreen(window.innerWidth >= 768);
        }
        window.addEventListener('resize', handleResize);
        handleResize(); // Initial check
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    // Add a function to format the date
    const formatDateForInput = (dateString) => {
        const currentDate = new Date(dateString);;
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const day = String(currentDate.getDate()).padStart(2, '0');
        const formattedDate = `${year}-${month}-${day}`;
        return formattedDate;
    };

    // FOR Current Date and Time 
    useEffect(() => {
        const currentDate = new Date();
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const day = String(currentDate.getDate()).padStart(2, '0');
        const formattedDate = `${year}-${month}-${day}`;
        setFormData((prevData) => ({
            ...prevData,
            BillDate: formattedDate,
            PaymentType: 1,
        }));
    }, []);

    return (
        <Fragment>
            <div className="w-full max-w-sm container mt-6 mx-auto" style={{ minWidth: '101%', marginTop: '-0.55%' }}>
                <div className="flex flex-wrap justify-between items-center mb-4">
                    <h6
                        className="uppercase tracking-wide text-black font-serif flex-grow"
                        style={{
                            fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif',
                            color: 'black',
                            marginTop: '-10px',
                        }}
                    >
                        Details JOURNAL Entry
                    </h6>
                    <div className="flex items-center w-full sm:w-auto sm:ml-4" style={{ marginRight: '120px', marginTop: '20px' }}>
                        <div className='w-full mb-2 flex'>
                            <label className="block tracking-wide text-gray-700 font-bold" style={{ color: 'darkblue' }}>
                                <input
                                    type="radio"
                                    name="IsType"
                                    value="1"
                                    checked={formData.IsType === true}
                                />
                                <span style={{ marginLeft: '5px', fontSize: '12px' }}>Debit</span>
                            </label>
                            <label className="block tracking-wide text-gray-700 font-bold ml-2" style={{ color: 'brown' }}>
                                <input
                                    type="radio"
                                    name="IsType"
                                    value="0"
                                    checked={formData.IsType === false}
                                />
                                <span style={{ marginLeft: '5px', fontSize: '12px' }}>Credit</span>
                            </label>
                        </div>
                    </div>

                    <div className="flex mt-8 w-full sm:w-auto" style={{ marginTop: '10px' }}>
                        <Button
                            variant="contained"
                            color="error"
                            component={Link}
                            to={{
                                 pathname: "/JournelEntryIndex",
                                state: { from: "/JournelEntry" },
                            }}
                            onClick={() => {
                                localStorage.setItem("shouldReload", "true");
                            }}
                            style={{ height: "25px", borderRadius: "10px", marginRight: "5px", marginLeft: '5px' }}
                        >
                            Back To List
                        </Button>
                    </div>
                </div>
            </div>

            <div className="watermark">
                <CopyrightIcon /><b style={{ fontFamily: 'Script Bold Italic' }}>EFFTABS SOLUTIONS LLP</b>
            </div>

            <div className="w-full flex flex-wrap md:flex-row flex-col">
                {/* Left Section: Entry Fields */}
                <div
                    className="flex-1 p-4"
                    style={{
                        backgroundColor: '#f3f3f3',
                        borderRadius: '10px',
                        marginTop: '-10px',
                    }}
                >
                    <div className="mb-3">
                        <div className="flex flex-wrap gap-x-4">
                            <div className="flex-1 w-1/3 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs mb-2" htmlFor="customer">
                                    Master <span className="text-red-500">*</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.MasterName}
                                    type="text"
                                    placeholder="Enter MasterName"
                                    name='MasterName'
                                    readOnly
                                />

                            </div>
                            <div className="w-1/5  mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs mb-2" htmlFor="billDate">
                                    Date <span className="text-red-500">*</span>
                                </label>
                                <input
                                    className="shadow border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:shadow-outline"
                                    type="date"
                                    value={formatDateForInput(formData.BillDate)}
                                    name="BillDate"
                                    readOnly
                                />
                            </div>
                            <div className="w-1/5 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs mb-2" htmlFor="billNumber">
                                    Number <span className="text-red-500">*</span>
                                </label>
                                <input
                                    className="shadow border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:shadow-outline"
                                    type="text"
                                    value={`${formData.BillNo || ''}/${formData.FinYear || ''}`}
                                    name="BillNo"
                                    readOnly
                                />
                            </div>
                        </div>
                        <div className="flex flex-wrap gap-x-4 mt-3">
                            <div className="flex-1  mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs mb-2" htmlFor="remarks">
                                    Remarks
                                </label>
                                <input
                                    className="shadow border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:shadow-outline"
                                    type="text"
                                    value={formData.Remarks}
                                    name="Remarks"
                                    readOnly
                                />
                            </div>
                            <div className="w-1/4  mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs mb-2" htmlFor="amount">
                                    Amount
                                </label>
                                <input
                                    className="shadow border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:shadow-outline text-right"
                                    type="number"
                                    value={formData.Amount}
                                    name="Amount"
                                    readOnly
                                />
                            </div>
                            <div className="w-1/6 mr-2">
                                <label
                                    className="block uppercase tracking-wide text-black text-xs mb-2 flex items-center gap-x-2"
                                    htmlFor="gstPercentage"
                                >
                                    GST %
                                    <input
                                        type="checkbox"
                                        className="form-checkbox h-4 w-4 text-red-700"
                                        name="IsIGST"
                                        checked={formData.IsIGST || false}
                                        style={{ marginLeft: '10px' }}
                                    />
                                    <span className="text-xs text-red-700" style={{ marginLeft: '5px' }}>IGST</span>
                                </label>
                                <select
                                    className="shadow border rounded w-full py-2 px-3 text-black-700 leading-tight focus:shadow-outline"
                                    name="GSTRate"
                                    value={formData.GSTRate || 0}
                                    disabled
                                >
                                    <option value={0}>0</option>
                                    <option value={3}>3</option>
                                    <option value={5}>5</option>
                                    <option value={12}>12</option>
                                    <option value={18}>18</option>
                                    <option value={28}>28</option>
                                </select>
                            </div>

                        </div>

                        <div className="flex flex-wrap items-center gap-x-4 mt-3">

                            <div className="w-1/6 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs mb-2" htmlFor="gstNumber">
                                    CGST : <span style={{ color: 'red', fontSize: '14px' }}>{formData.CGSTAmount}</span>
                                </label>
                            </div>

                            <div className="w-1/6 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs mb-2" htmlFor="gstNumber">
                                    SGST : <span style={{ color: 'red', fontSize: '14px' }}>{formData.SGSTAmount}</span>
                                </label>
                            </div>

                            <div className="w-1/6 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs mb-2" htmlFor="gstNumber">
                                    IGST : <span style={{ color: 'red', fontSize: '14px' }}>{formData.IGSTAmount}</span>
                                </label>
                            </div>

                            <div className="w-1/6 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs mb-2" htmlFor="gstNumber">
                                    R.Off : <span style={{ color: 'red', fontSize: '14px' }}>{formData.RoundOff}</span>
                                </label>
                            </div>

                            <div className="w-1/6 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs mb-2" htmlFor="gstNumber">
                                    Total : <span style={{ color: 'red', fontSize: '14px' }}>{formData.TotalAmount}</span>
                                </label>
                            </div>
                        </div>

                    </div>
                </div>

                {/* Right Section: Table */}
                <div className="flex-1 p-4">
                    <div className="rounded-lg shadow overflow-hidden" style={{ backgroundColor: '#EDDFE0', marginTop: '-1.95%' }}>
                        <TableContainer component={Paper}>
                            <Table>
                                <TableHead sx={{ backgroundColor: '#f3f3f3' }}>
                                    <TableRow>
                                        <TableCell colSpan={4} sx={{ textAlign: 'center', fontWeight: 'bold', color: 'darkblue', padding: '4px' }}>
                                            SELECTED MASTER LIST
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell style={{ padding: '4px' }}>Party</TableCell>
                                        <TableCell style={{ padding: '4px' }}>Amount</TableCell>

                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {selectedItems.length > 0 ? (
                                        selectedItems.map((raterelation, index) => (
                                            <TableRow key={index}>
                                                <TableCell style={{ padding: '3px' }}>{raterelation.MasterName}</TableCell>
                                                <td style={{ padding: '3px', textAlign: 'right', width: '100px' }}>
                                                    <input
                                                        type="number"
                                                        value={raterelation.Amount}
                                                        className="w-full px-1 py-1 border rounded-md focus:outline-none focus:ring-2 focus:ring-yellow-400"
                                                        style={{ fontSize: '13px', fontWeight: 'bold', backgroundColor: '#FFCF96', textAlign: 'right' }}
                                                        min="0"
                                                        aria-label={`amount for master ${raterelation.Id}`}
                                                        name="Amount"
                                                        readOnly
                                                    />
                                                </td>

                                            </TableRow>
                                        ))
                                    ) : (
                                        <TableRow>
                                            <TableCell colSpan={4} align="center">
                                                No Items Selected
                                            </TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </div>
                </div>
            </div>



        </Fragment >
    );
};


export default JournalEntryDetails;
